// TODO: This is currently all built around the index of the recipe being a key. This will probably break when adding
// more recipes, so eventually consider a longer term solution
import fakeRecipes from './recipes/data.json'

export const getRecipe = (key) => fakeRecipes[key]
export const getRecipes = (keys, meals) =>
  keys.slice(0, meals).map((key) => getRecipe(key))

export const filterRecipes = (requirements) => {
  let keys = []

  fakeRecipes.forEach(({ diets }, index) => {
    if (
      requirements.length === 0 ||
      requirements.every((requirement) => diets.includes(requirement))
    ) {
      keys.push(index)
      return
    }
  })

  return keys
}

export const clampQuantity = (quantity) => parseFloat(quantity.toFixed(2))
